import gql from 'graphql-tag';

const MEMBER_LICENSE_CARD_REQUEST_CANCEL = gql`
mutation memberLicenseCardRequestCancel($id: ID!) {
	memberLicenseCardRequestCancel (id: $id) {
		id
    bid
  }
}
`;

export default MEMBER_LICENSE_CARD_REQUEST_CANCEL;